import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Service, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {IecTask} from '../tasks/iec-task';
import {GoogleService} from './google-service';

@Service()
export class IecTaskService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private readonly urlBase: string = environment.serviceUrl + 'iecTasks/';

  public findMyWorkflowTasks(): Observable<IecTask[]> {
    let url = this.urlBase + 'user';
    return this.http.get<IecTask[]>(url, {headers: this.getRequestHeaders()});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  public getTask(id: number): Observable<IecTask> {
    let url = this.urlBase + id;
    return this.http.get<IecTask>(url, {headers: this.getRequestHeaders()});
  }

  getAssignedTo(token: string): Observable<string> {
    const url = this.urlBase + 'assignedTo/' + token;
    return this.http.get(url, {headers: this.getRequestHeaders(), responseType: 'text'});
  }

  getActiveTasksByNameAndEntity(taskName: string, entityId: string, revision: number): Observable<IecTask[]> {
    const url = this.urlBase + encodeURIComponent(taskName) + '/' + entityId + '/' + revision;
    return this.http.get<IecTask[]>(url, {headers: this.getRequestHeaders()});
  }

}
